class QueueListHelper {
    static filter(queues, searchString, periods) {
        let supporter;
        let queue;
        let searchStringParts = searchString.split(" ");
        let foundSearchString;
        for(let i = 0; i < queues.length; i++) {
            queue = queues[i];
            for(let j = 0; j < queue.supporters.length; j++) {
                supporter = queue.supporters[j];
                if(searchString.length > 0) {
                    foundSearchString = false;
                    for(let j = 0; j < searchStringParts.length; j++) {
                        foundSearchString = foundSearchString || (supporter.supporter.firstname.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1 || supporter.supporter.lastname.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1 || supporter.supporter.email.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1);
                    }
                    supporter.hidden = !foundSearchString;
                } else {
                    supporter.hidden = false;
                }
                if(periods.length > 0) {
                    supporter.hidden = supporter.hidden || !(periods.map((period) => parseInt(period, 10)).includes(supporter.currentPeriodId));
                }
            }
        }
        return queues;
    }

    static toggleCollapse(queues, id) {
        let queue;
        for(let i = 0; i < queues.length; i++) {
            queue = queues[i];
            if(parseInt(queue.id, 10) === parseInt(id, 10)) {
                queue.collapsed = (queue.collapsed === undefined || queue.collapsed === false);
                break;
            }
        }

        return queues;
    }
}

export default QueueListHelper;